module.exports = __webpack_public_path__ + "img/_e-ABOUTUS.cefd324a.png";